import React from "react";
import { Box, Button, Typography, useTheme } from "@mui/material";

const GroupedSidebarNav = ({ groups = [], value, onChange, sx }) => {
  const theme = useTheme();
  
  const handleSelect = (nextValue) => {
    if (!onChange) return;
    onChange(nextValue);
  };

  return (
    <Box
      sx={{
        minWidth: { xs: "100%", sm: 240 },
        bgcolor: theme.palette.background.default,
        borderRadius: { xs: "12px", sm: "0 12px 12px 0" },
        border: `1px solid ${theme.palette.primary.border2}`,
        p: "0.75rem",
        mt: "0.25rem",
        boxShadow: theme.shadows[3],
        display: "flex",
        flexDirection: "column",
        gap: 1,
        overflowY: "auto",
        ...sx,
      }}
    >
      {groups.map((group) => (
        <Box key={group.title} sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          <Typography
            variant="body2"
            sx={{
              px: 1,
              pt: 0.5,
              pb: 0.25,
              fontWeight: 700,
              color: theme.palette.primary.main,
              textTransform: "uppercase",
              letterSpacing: "0.04em",
              fontSize: "0.82rem",
            }}
          >
            {group.title}
          </Typography>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.25, pl: 1 }}>
            {group.items.map((item) => {
              const isSelected = value === item.value;
              return (
                <Button
                  key={`${group.title}-${item.value}`}
                  onClick={() => handleSelect(item.value)}
                  variant="text"
                  sx={{
                    justifyContent: "flex-start",
                    textTransform: "none",
                    borderRadius: "8px",
                    pl: 2,
                    pr: 1.25,
                    py: 0.9,
                    color: isSelected ? theme.palette.primary.main : theme.palette.text.secondary,
                    bgcolor: isSelected ? theme.palette.action.selected : "transparent",
                    fontWeight: isSelected ? 700 : 500,
                    fontSize: "0.95rem",
                    "&:hover": {
                      bgcolor: isSelected
                        ? theme.palette.action.selected
                        : theme.palette.action.hover,
                    },
                  }}
                >
                  {item.label}
                </Button>
              );
            })}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default GroupedSidebarNav;